import { render } from "./SystemImport.vue?vue&type=template&id=0630c66a&ts=true"
import script from "./SystemImport.vue?vue&type=script&lang=ts"
export * from "./SystemImport.vue?vue&type=script&lang=ts"

import exportComponent from "D:\\repos\\Platform\\frontend\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__